// eslint-disable-next-line no-useless-escape
export const regExpSpecialSymbols = /[\!\#\$\%\^\&\*\)\(\+\=\.\<\>\{\}\[\]\:\;\'\"\|\~\`\_\-]/g;
